






import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { ROUTE_NAMES } from "@/router/routenames";

@Component
export default class Home extends Vue {}
